<template>
  <div>
    <div class="blur" v-show="isConfirmPopup"></div>
    <div v-if="style === '0'" class="AAAAAAA">
      <div class="confirmPopup" v-show="isConfirmPopup">
        <img v-on:click="close()" src="../assets/close.png" width="36px" height="36px" style=" position: absolute; top:8px; right: 8px; width: 36px;">
        <h2 style="text-align:center;">以下のお客様情報で決済手続きを進めてよろしいでしょうか？</h2>
        <p><span style="font-weight: bold;">購入するサービス: </span>{{ product }}</p>
        <div v-if="plan === 0">
          <div v-if="whichTestForGuest === '宿泊前検査'"><p><span style="font-weight: bold;">検査の種類: </span>宿泊前検査</p><p><span style="font-weight: bold;">送付先住所: </span>{{ address }}</p></div>
          <div v-else-if="whichTestForGuest === 'ご帰宅後検査'"><p><span style="font-weight: bold;">検査の種類: </span>ご帰宅後検査</p><p><span style="font-weight: bold;">送付先住所: </span>{{ address }}</p></div>
          <div v-else><p><span style="font-weight: bold;">検査の種類: </span>宿泊中検査</p></div>
        </div>
        <p><span style="font-weight: bold;">お名前: </span>{{ name }}</p>
        <p><span style="font-weight: bold;">電話番号: </span>{{ tel }}</p>
        <div v-if="hotelName === 'C'">
        </div>
        <div v-else>
          <p><span style="font-weight: bold;">お部屋番号: </span>{{ room }}</p>
        </div>
        <p><span style="font-weight: bold;">症状の有無: </span>{{ selected }}</p>
        <div v-if="plan === 0">
          <div v-if="isExpress === '無'"><p><span style="font-weight: bold;">エクスプレス対応の有無: </span>無</p></div>
          <div v-else><p><span style="font-weight: bold;">エクスプレス対応の有無: </span>有</p></div>
        </div>
        <div v-if="plan === 3">
          <div v-if="whichTest === '定性検査 +14,300'"><p><span style="font-weight: bold;">検査の種類: </span>定性検査</p></div>
          <div v-else><p><span style="font-weight: bold;">検査の種類: </span>定量検査</p></div>
        </div>

         <div v-if="isTestMode">
           <payjp-checkout
            api-key="pk_test_dbcf99f9a7785879cc537fa6"
            text="text"
            lang="en"
            submit-text="テスト購入 /  Test Buy"
            name-placeholder="TARO TANAKA"
            v-on:created="onTokenCreated"
            v-on:failed="onTokenFailed">
          </payjp-checkout>
         </div>
         <div v-else>
           <payjp-checkout
            api-key="pk_live_ed9ec656346e82c82daa81de"
            text="text"
            lang="en"
            submit-text="購入 /  Buy"
            name-placeholder="TARO TANAKA"
            v-on:created="onTokenCreated"
            v-on:failed="onTokenFailed">
          </payjp-checkout>
         </div>

      </div>
    </div>
    <div v-else class="BBVBBBB">
      <div class="confirmPopup" v-show="isConfirmPopup">
        <img v-on:click="close()" src="../assets/close.png" width="36px" height="36px" style=" position: absolute; top:8px; right: 8px; width: 36px;">
        <h2 style="text-align:center;">May I continue your settlement process?</h2>
        <p><span style="font-weight: bold;">Service: </span>{{ product }}</p>
        <div v-if="plan === 0">
          <div v-if="whichTestForGuest === '宿泊前検査'"><p><span style="font-weight: bold;">test category: </span>The test before check-in</p><p><span style="font-weight: bold;">address of destination: </span>{{ address }}</p></div>
          <div v-else-if="whichTestForGuest === 'ご帰宅後検査'"><p><span style="font-weight: bold;">test category: </span>The test after returning home</p><p><span style="font-weight: bold;">address of destination: </span>{{ address }}</p></div>
          <div v-else><p><span style="font-weight: bold;">test category: </span>The test during your stay</p></div>
        </div>
        <p><span style="font-weight: bold;">name: </span>{{ name }}</p>
        <p><span style="font-weight: bold;">tel: </span>{{ tel }}</p>
        <div v-if="hotelName === 'C'">
        </div>
        <div v-else>
          <p><span style="font-weight: bold;">room: </span>{{ room }}</p>
        </div>
        <p><span style="font-weight: bold;">presence or absence of symptoms: </span>{{ selected }}</p>
        <div v-if="plan === 0">
          <div v-if="isExpress === 'no'"><p><span style="font-weight: bold;">presence or absence of express: </span>no</p></div>
          <div v-else><p><span style="font-weight: bold;">presence or absence of express: </span>yes</p></div>
        </div>
        <div v-if="plan === 3">
          <div v-if="whichTest === 'Qualitative Test +14,300'"><p><span style="font-weight: bold;">test category: </span>Qualitative Test</p></div>
          <div v-else><p><span style="font-weight: bold;">test category: </span>Quantitative Test</p></div>
        </div>

        <div v-if="isTestMode">
          <payjp-checkout
          api-key="pk_test_dbcf99f9a7785879cc537fa6"
          text="Please enter your test settlement information.111"
          submit-text="テスト購入 /  Test Buy"
          lang="en"
          name-placeholder="TARO TANAKA"
          v-on:created="onTokenCreated"
          v-on:failed="onTokenFailed">
          </payjp-checkout>
        </div>
        <div v-else>
          <payjp-checkout
          api-key="pk_live_ed9ec656346e82c82daa81de"
          text="Please enter your settlement information.222"
          submit-text="Purchase"
          lang="en"
          name-placeholder="TARO TANAKA"
          v-on:created="onTokenCreated"
          v-on:failed="onTokenFailed">
          </payjp-checkout>
        </div>
        
        
      </div>
    </div>
    <Loading v-show="loading"></Loading>
    <div class="select-os">
        <input type="radio" id="japanese" name="launguage" v-model="style" value="0" class="japanese" checked>
        <label for="japanese">
            日本語
        </label>
        <input type="radio" id="english" name="launguage" v-model="style" value="1" class="english">
        <label for="english">
            English
        </label>
    </div>
    <div id="top" v-if="isPasscodeCorrect">
      <div v-if="style === '0'">
        <img src="../assets/lp1.png">
        <!--
        <p>ホテル名：{{ hotelName }}</p>
        <p>プラン名：{{ planName }}</p>-->
          <img v-if="plan === 0" src="../assets/lp3.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else-if="plan === 1" src="../assets/lp4.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else-if="plan === 2" src="../assets/lp5.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else src="../assets/lp6.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">


    <!--ビデオ-->
    <video v-if="plan === 0" controls src="https://weart-marketing.com/assets/movies/pcr_japanese_0429.mp4" poster="../assets/thumbnail.png"></video>
       
        <div class="contact-form">
          <h2>ユーザー情報入力</h2>
          <table style="border-collapse: separate; border-spacing: 0px 1.5em;width: 100%;">
            <tbody>
              <div v-if="plan === 0" class="inner-div">
                <!--検査の種類を３つ ①宿泊前検査　②ご帰宅後検査 ③宿泊中検査-->
                <div class="radio-inner">
                  <input type="radio" id="one" value="宿泊前検査" v-model="whichTestForGuest">
                  <label for="one">宿泊前検査</label>
                  <input type="radio" id="two" value="ご帰宅後検査" v-model="whichTestForGuest">
                  <label for="two">ご帰宅後検査</label>
                  <input type="radio" id="three" value="宿泊中検査" v-model="whichTestForGuest">
                  <label for="three">宿泊中検査</label>
                </div>
                <div class="form1" v-if="whichTestForGuest === '宿泊前検査'">
                  <tr><td class="key">お名前：</td><td class="value"><input type="text" placeholder="お名前" v-model="name" required></td></tr>
                  <tr><td class="key">送付先住所：</td><td class="value"><input type="text" placeholder="送付先住所" v-model="address" required></td></tr>
                  <tr><td class="key">お電話番号：</td><td class="value"><input type="tel" placeholder="お電話" v-model="tel" required></td></tr>
                  
                </div>
                <div class="form2" v-else-if="whichTestForGuest === 'ご帰宅後検査'">
                  <tr><td class="key">お名前：</td><td class="value"><input type="text" placeholder="お名前" v-model="name" required></td></tr>
                  <tr><td class="key">送付先住所：</td><td class="value"><input type="text" placeholder="送付先住所" v-model="address" required></td></tr>
                  <tr><td class="key">お電話番号：</td><td class="value"><input type="tel" placeholder="お電話" v-model="tel" required></td></tr>
                </div>
                <div class="form3" v-else="whichTestForGuest === '宿泊中検査'">
                  <tr><td class="key">お名前：</td><td class="value"><input type="text" placeholder="お名前" v-model="name" required></td></tr>
                  <tr><td class="key">お電話番号：</td><td class="value"><input type="tel" placeholder="お電話" v-model="tel" required></td></tr>
                  <tr v-if="hotelName === 'A' || hotelName === 'B'">
                    <td class="key">客室番号：</td><td class="value"><input type="text" placeholder="客室番号" v-model="room" required></td>
                  </tr>
                  <tr><td class="key">エクプレス対応(オプション+5500税込)：</td><td class="value"><select v-model="isExpress" class="option">
                  <option disabled value="選択して下さい">選択して下さい</option>
                  <option v-for="option in options" v-bind:value="option.name" v-bind:key="option.id">
                          {{ option.name }}
                  </option> </select></td></tr>
                </div>

             

              </div>
              <div v-if="plan === 2" class="inner-div">
                <tr><td class="key">お名前：</td><td class="value"><input type="text" placeholder="お名前" v-model="name" required></td></tr>
                <tr><td class="key">お電話番号：</td><td class="value"><input type="tel" placeholder="お電話" v-model="tel" required></td></tr>
                <tr v-if="hotelName === 'A' || hotelName === 'B'"><td class="key">客室番号：</td><td class="value"><input type="text" placeholder="客室番号" v-model="room" required></td></tr>
                <tr><td class="key">パスポートの画像：</td>
                <td class="file"><input type="file" name="passport_image" id="passport_image" @change="onFileChange1" accept=".png, .jpg, .jpeg, .gif" required><label>※.jpg、.gif、.pngの画像ファイル</label></td></tr>
                <tr><td class="key" colspan="2"><div class="imagePreview">  
                  <img :src="uploadedPassportImage" style="width:100%;" />
                </div></td></tr>
                <tr><td class="key">フライトチケットの画像：</td>
                <td class="file"><input type="file" name="ticket_image" id="ticket_image" @change="onFileChange2" accept=".png, .jpg, .jpeg, .gif"><label>※.jpg、.gif、.pngの画像ファイル</label></td></tr>
                <tr><td colspan="2"><div class="imagePreview">  
                  <img :src="uploadedTicketImage" style="width:100%;" />
                </div></td></tr>
  
              </div>
              <div v-if="plan === 3" class="inner-div">
                <tr><td class="key">お名前：</td><td class="value"><input type="text" placeholder="お名前" v-model="name" required></td></tr>
                <tr><td class="key">お電話番号：</td><td class="value"><input type="tel" placeholder="お電話" v-model="tel" required></td></tr>
                <tr v-if="hotelName === 'A' || hotelName === 'B'"><td class="key">客室番号：</td><td class="value"><input type="text" placeholder="客室番号" v-model="room" required></td></tr>
                <!--検査の種類(定性or定量)-->
                <tr><td class="key">検査の種類(定性or定量)：</td><td class="value"><select v-model="whichTest" class="option">
                  <option disabled value="選択して下さい">選択して下さい</option>
                  <option v-for="o in testOptions" v-bind:value="o.name" v-bind:key="o.id">
                          {{ o.name }}
                  </option>
                </select></td></tr>
              </div>

              <!--症状があるかどうか-->
              <tr><td class="ful" colspan="2">症状の有無(以下のような症状がある場合は有を選択してください。)：</td></tr>
              <tr><td class="ful" colspan="2"><label class="small-text">発熱 / 空咳 / 倦怠感 / 痛み / 喉の痛み / 下痢 / 結膜炎 / 頭痛 / 味覚または嗅覚の消失 / 皮膚の発疹、<br>または手足の指の変色 / 呼吸が苦しいまたは息切れ / 胸の痛みまたは圧迫感 / 言語障害または運動機能の喪失</label></td></tr>

              <tr><td class="ful" colspan="2"><select v-model="selected" class="option">
                <option disabled value="選択して下さい">選択して下さい</option>
                <option v-for="option in options" v-bind:value="option.name" v-bind:key="option.id">
                        {{ option.name }}
                </option>
              </select></td></tr>

              <tr v-if="plan === 2"><td class="ful" colspan="2"><span class="attention">注意:</span>ご購入が完了しましたら、弊社担当者よりお電話をさせていただき、詳細を打ち合わせさせていただきます。宜しくお願い致します。</td></tr>


              <tr v-if="plan === 3"><td class="ful" colspan="2"><span class="attention">注意:</span>ご予約が確認でき次第折り返しお電話をさせていただきます。電話が来ない場合又は営業時間外の場合、コンシェルジュまでお問い合わせください。</td></tr>

              <tr><td colspan="2"><button id="pay" @click="confirmPopup">決済情報を入力する</button></td></tr>
            </tbody>
          </table>

        </div>
        <img src="../assets/bottom.png">
      </div>
       <div v-else>
        <img src="../assets/lp1_en.png">
        <!--
        <p>ホテル名：{{ hotelName }}</p>
        <p>プラン名：{{ planName }}</p>-->
        <img v-if="plan === 0" src="../assets/lp3_en.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else-if="plan === 1" src="../assets/lp4_en.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else-if="plan === 2" src="../assets/lp5_en.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
          <img v-else src="../assets/lp6_en.png" style="margin-top: 2em;width: 90%;
    margin: 0 auto;">
   
    <video v-if="plan === 0" controls src="https://weart-marketing.com/assets/movies/pcr_english_0429.mp4" poster="../assets/thumbnail-en.png"></video>
        <div class="contact-form">
          <h2>User Form</h2>
          <table style="border-collapse: separate; border-spacing: 0px 1.5em;width: 100%;">
            <tbody>
              <div v-if="plan === 0" class="inner-div">
                <!--検査の種類を３つ ①宿泊前検査　②ご帰宅後検査 ③宿泊中検査-->
                <div class="radio-inner">
                  <input type="radio" id="one" value="宿泊前検査" v-model="whichTestForGuest">
                  <label for="one">The test before check-in</label>
                  <input type="radio" id="two" value="ご帰宅後検査" v-model="whichTestForGuest">
                  <label for="two">The test after returning home</label>
                  <input type="radio" id="three" value="宿泊中検査" v-model="whichTestForGuest">
                  <label for="three">The test during your stay</label>
                </div>

                <div class="form1" v-if="whichTestForGuest === '宿泊前検査'">
                  <tr><td class="key">name：</td><td class="value"><input type="text" placeholder="name" v-model="name" required></td></tr>
                  <tr><td class="key">address of destination：</td><td class="value"><input type="text" placeholder="address" v-model="address" required></td></tr>
                  <tr><td class="key">tel：</td><td class="value"><input type="tel" placeholder="tel" v-model="tel" required></td></tr>
                  
                </div>
                <div class="form2" v-else-if="whichTestForGuest === 'ご帰宅後検査'">
                  <tr><td class="key">name：</td><td class="value"><input type="text" placeholder="name" v-model="name" required></td></tr>
                  <tr><td class="key">address of destination：</td><td class="value"><input type="text" placeholder="address" v-model="address" required></td></tr>
                  <tr><td class="key">tel：</td><td class="value"><input type="tel" placeholder="tel" v-model="tel" required></td></tr>
                </div>
                <div class="form3" v-else="whichTestForGuest === '宿泊中検査'">
                  <tr><td class="key">name：</td><td class="value"><input type="text" placeholder="name" v-model="name" required></td></tr>
                  <tr><td class="key">tel：</td><td class="value"><input type="tel" placeholder="tel" v-model="tel" required></td></tr>
                  <tr v-if="hotelName === 'A' || hotelName === 'B'"><td class="key">room：</td><td class="value"><input type="text" placeholder="room" v-model="room" required></td></tr>
                  <tr><td class="key">the presence or absence of express(+5500 yen)：</td><td class="value"><select v-model="isExpress" class="option">
                  <option disabled value="Select(optional)">Select(optional)</option>
                  <option v-for="option in englishOptions" v-bind:value="option.name" v-bind:key="option.id">
                          {{ option.name }}
                  </option></select></td></tr>
                </div>

                
                
              </div>
              <div v-if="plan === 2" class="inner-div">
                <tr><td class="key">name：</td><td class="value"><input type="text" placeholder="name" v-model="name" required></td></tr>
                <tr><td class="key">tel：</td><td class="value"><input type="tel" placeholder="tel" v-model="tel" required></td></tr>
                <tr v-if="hotelName === 'A' || hotelName === 'B'"><td class="key">room：</td><td class="value"><input type="text" placeholder="room" v-model="room" required></td></tr>
                <tr><td class="key">The image of passport：</td><td class="file">
                <input type="file" name="passport_image" id="passport_image" @change="onFileChange1" accept=".png, .jpg, .jpeg, .gif" required><label>※.jpg、.gif、.png</label></td></tr>
                <tr><td class="key" colspan="2"><div class="imagePreview">  
                  <img :src="uploadedPassportImage" style="width:100%;" />
                </div></td></tr>
                <tr><td class="key">The image of flight-ticket：</td><td class="file">
                <input type="file" name="ticket_image" id="ticket_image" @change="onFileChange2" accept=".png, .jpg, .jpeg, .gif"><label>※.jpg、.gif、.png</label></td></tr>
                <tr><td class="key" colspan="2"><div class="imagePreview">  
                  <img :src="uploadedTicketImage" style="width:100%;" />
                </div></td></tr>
                 
              </div>
              <div v-if="plan === 3" class="inner-div">
                <tr><td class="key">name：</td><td class="value"><input type="text" placeholder="name" v-model="name" required></td></tr>
                <tr><td class="key">tel：</td><td class="value"><input type="tel" placeholder="tel" v-model="tel" required></td></tr>
                <tr v-if="hotelName === 'A' || hotelName === 'B'"><td class="key">room：</td><td class="value"><input type="text" placeholder="room" v-model="room" required></td></tr>
                <!--検査の種類(定性or定量)-->
                <tr><td class="key">test category(Qualitative Test or Quantitative Test)：</td><td class="value"><select v-model="whichTest" class="option">
                  <option disabled value="Select">Select</option>
                  <option v-for="o in testEnglishOptions" v-bind:value="o.name" v-bind:key="o.id">
                          {{ o.name }}
                  </option>
                </select></td></tr>
                

              </div>
              <!--症状があるかどうか-->
              <tr><td class="ful" colspan="2">presence or absence of symptoms:</td></tr>
              <tr><td class="ful" colspan="2"><label class="small-text">fever/cough/malaise/sore throat/diarrhea/conjunctivitis/headache/loss of smell and taste/skin rash<br>/shortness of breath/chest pain/difficulty in speech or movement disorder</label></td></tr>
              <tr><td class="ful" colspan="2">
              <select v-model="selected" class="option">
                <option disabled value="Select">Select</option>
                <option v-for="option in englishOptions" v-bind:value="option.name" v-bind:key="option.id">
                        {{ option.name }}
                </option>
              </select></td></tr>
              <tr v-if="plan === 2"><td class="ful" colspan="2"><span class="attention">Attention:</span> Once your purchase is complete,our staff call you and　we want to discuss the details.</td></tr>
              <tr v-if="plan === 3"><td class="ful" colspan="2"><span class="attention">Attention:</span>We will call you back as soon as your reservation is confirmed.Contact the concierge if you do not receive a call or are out of business hours.</td></tr>

              <tr><td colspan="2"><button id="pay" @click="confirmPopup">Please enter your settlement information.</button></td></tr>
            </tbody>
          </table>
        </div>
        <img src="../assets/bottom_en.png">
       </div>
    </div>
    <div id="lp" v-else>
      <div class="card-content" v-if="style === '0'">
      <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
      <input type="text" placeholder="パスコード" v-model="passcode">
      <button id="login" @click="check">パスコード認証</button>
      <!--<p>本サービスに関する<a href="#" style="color: #5D99FF;">利用規約</a>はこちらへ。</p>-->
      </div>

      <div class="card-content" v-else>
      <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
      <input type="text" placeholder="passcode" v-model="passcode">
      <button id="login" @click="check">Passcode Authentication</button>
      <!--<p>Confirm <a href="#" style="color: #5D99FF;">Our Terms</a> Of Service</p>-->
      </div>
    </div>
    <!--
    <p>ホテル名：{{ hotelName }}</p>
    <p>プラン名：{{ planName }}</p>
    <p>↓↓ここクリックで課金テスト</p>
    <payjp-checkout
    api-key="pk_test_dbcf99f9a7785879cc537fa6"
    text="カード情報を入力"
    submit-text="購入"
    name-placeholder="TARO TANAKA"
    v-on:created="onTokenCreated"
    v-on:failed="onTokenFailed">
    </payjp-checkout>
    <button id="pay">課金する</button>
    <p>↓↓ここクリックでログインテスト</p>
    <button id="login">ログインする</button>-->
  </div>
</template>
<style scoped>
h1, h2 {
  font-weight: bold;
}
.select-os{
  position: absolute;
  top: 2em;
  right: 2em;
  text-align: end;
}
video{width: 60%;margin-top: 2em;margin-bottom: 2em;}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img{
    width: 100%;
  }
  #lp img{width: 60%;margin-top: 5%;margin-bottom: 5%;}
#lp{position: absolute;top: 50%;left: 50%;width: 30%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}

#lp input{
  display: block;
  width: 90%;
  height: 40px;
  margin: 16px auto;
  font-size: 1em;
}
.inner-div{display: contents;}
.key{width: 30%;}
.value{width: 70%;}
.value input{width: 80%;height: 2em;}
.file input {width: 200px; height: 2em;}
.spbr{display: none;}
h1{
 margin: 0px;
}
body{
  margin: 0px;
}
#lp #login{
display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 8% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;
}

#lp #login:hover{
  opacity: 0.7;
}
.card-content{
  padding:8px;
  width: 100%;
  height: auto;
  background-color: white;
  margin: 0 auto;
}
.blur{
  width: 100%;
  height: 100%;
  z-index: 1000;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0,0,0,0.8);
}
.confirmPopup{
  z-index: 1001;
  position: fixed;
  height: auto;
  background: white;
  left: 30%;
  z-index: 5000;
  padding: 24px;
  top: 20%;
  transition: .6s;
  box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.4);
  width: 40%;
}
.confirmPopup h2{
  font-size: 1em;
}
.confirmPopup p{
  font-size: 1em;
  text-align: left;
}
.form1{display: inline;}
.form2{display: inline;}
.form3{display: inline;}
#pay{display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 8% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;}
  .option{    height: 2.5em;width: 40%;}
  .attention{color: red; font-weight: bold; font-size: 1.2em;}
@media screen and (max-width:780px) {

#lp img{width: 80%;margin-top: 5%;margin-bottom: 5%;}
#lp{position: absolute;top: 50%;left: 50%;width: 80%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}

.spbr{display: block;}

.card-content p{font-size: .8em;}
.select-os{
  position: inherit;
  top: 0px;
  right: 0em;
  text-align: center;
    margin-top: 2em;
    margin-bottom: 2em;
    position: inherit;
    top: 0px;
}
video{width: 90%;margin-top: 2em;margin-bottom: 2em;}
.confirmPopup img{top: -4px;
    right: 4px;}
    .confirmPopup{
  
  left:5%;
  
  padding: 5%;

  width: 80%;
}
.contact-form{
  width: 90%;
  margin: 0 auto;
}
}

.small-text{font-size: .9em;}
.imagePreview{
  width: 200px;
  margin: 8px auto;
}


.select-os input {
  display: none;
}
.select-os input[type="radio"]:checked.japanese + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os input[type="radio"]:checked.english + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os label {
  color: #ddd;
  border: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding: 5px 0px;
  width: 120px;
}
.select-os label:hover {
    color: #aaa;
    border: 2px solid #aaa;
    cursor: pointer;
}
</style>

<script>
import $ from 'jquery'
import firebase from 'firebase'
import Loading from './common/Loading'
export default {
  name: 'Home',
  components: {
    Loading
  },
  data () {
    return {
      db: null,
      loading: null,
      msg: 'Welcome to 株式会社Kirarin様',
      tokenId: null,
      hotelName: null,
      userId: null,
      mail: null,
      plan: null,
      planName: null,
      passcode: null,
      whichTestForGuest: '宿泊中検査',
      isPasscodeCorrect: false,
      isTestMode: false,
      isExpress: '無(no)',
      isConfirmPopup: false,
      uploadedPassportImage: null,
      uploadedTicketImage: null,
      name: null,
      address: null,
      places: [],
      tel: null,
      room: null,
      selected: '',
      apiKey:'',
      text:'',
      submitText:'',
      options: [
      { id: 1, name: '有' },
      { id: 2, name: '無' }
      ],
      englishOptions: [
      { id: 3, name: 'yes' },
      { id: 4, name: 'no' }
      ],
      whichTest: null,
      testOptions: [
      { id: 5, name: '定性検査 +14,300' },
      { id: 6, name: '定量検査 +19,800' }
      ],
      testEnglishOptions: [
      { id: 7, name: 'Qualitative Test +14,300' },
      { id: 8, name: 'Quantitative Test +19,800' }
      ],
      style: null
    }
  },
  created: function () {
    // セキュリティのためローカルにあるuserIdは正しいかチェック
    this.db = firebase.firestore()
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.hotelName = result['place']
    this.plan = parseInt(result['plan'], 10)
    this.mail = result['mail']
    if (!result['style']) {
      this.style = '0'
    } else {
      this.style = result['style']
    }

    console.log('dxiuswghdiueqwghdiouqwgdqw')
    console.log(document.URL)
    console.log('dxiuswghdiueqwghdiouqwgdqw')


    if (document.URL.includes('localhost:8080')) {
      this.isTestMode = true
    } else  {
      this.isTestMode = false
    }

    switch (this.plan) {
      case 0:
        this.planName = '宿泊者様PCR検査'
        break
      case 1:
        this.planName = 'パーティ参加者様事前PCR検査'
        break
      case 2:
        this.planName = '海外渡航陰性証明書'
        break
      case 3:
        this.planName = '医師派遣&抗原検査'
        break
      default:
        this.planName = 'その他'
    }

  },
  methods: {
    onTokenCreated (token) {
      let self = this
      self.isConfirmPopup = false
      this.tokenId = token.id
  
      // 購入するプラン名で条件分岐
      self.loading = true
      var data = null


      switch (this.plan) {
        case 0:
          var amount = 22000
          if (self.style === '0') {
            if (this.isExpress === '有') {
              amount = amount + 5500
            }
          } else {
            if (this.isExpress === 'yes') {
              amount = amount + 5500
            }
          }

          

          // 本番環境
          /*
          data = { 'token': this.tokenId, 'amount': amount, 'description': this.userId, 'plan': 0 }
          $.ajax({
            url: 'https://weart-marketing.com/api/',
            type: 'POST',
            data: data
          }).done(function (data) {
            // 購入完了情報をユーザー情報に保存

            self.updateUserClass(data)

          }).fail(function () {
            self.loading = false
            if (self.style === '0') {
              alert('一時的なサーバーエラーが発生しました。')
            } else {
              alert('System error has temporarily occurred.')
            }
            location.href = "/error?style=" + self.style
          })*/


          if (document.URL.includes('localhost:8080')) {

            //テスト環境
            data = { 'token': this.tokenId, 'amount': amount, 'description': this.userId, 'plan': 0 }
            $.ajax({
              url: 'https://weart-marketing.com/api/test/',
              type: 'POST',
              data: data
            }).done(function (data) {
              // 購入完了情報をユーザー情報に保存

              self.updateUserClass(data)

            }).fail(function () {
              self.loading = false
              if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
              } else {
                alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
          } else {
             console.log('テストでない')
             // 本番環境
            data = { 'token': this.tokenId, 'amount': amount, 'description': this.userId, 'plan': 0 }
            $.ajax({
              url: 'https://weart-marketing.com/api/',
              type: 'POST',
              data: data
            }).done(function (data) {
              // 購入完了情報をユーザー情報に保存

              self.updateUserClass(data)

            }).fail(function () {
              self.loading = false
              if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
              } else {
                alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })

          }

          
          break
        case 1:
          self.loading = false
          break
        case 2:

        var url = null
        if (document.URL.includes('localhost:8080')) {
          url = 'https://weart-marketing.com/api/test/'
        } else {
          url = 'https://weart-marketing.com/api/'
        }



          data = { 'token': this.tokenId, 'amount': 44000, 'description': this.userId, 'plan': 2 }
          $.ajax({
            url: url,
            type: 'POST',
            data: data
          }).done(function (data) {
            // 購入完了情報をユーザー情報に保存

            self.updateUserClass(data)

            // 購入完了ページへ
            //location.href = '/success?plan=1'

          }).fail(function () {
            self.loading = false
            if (self.style === '0') {
              alert('一時的なサーバーエラーが発生しました。')
            } else {
              alert('System error has temporarily occurred.')
            }
            location.href = "/error?style=" + self.style
          })
          break
        case 3:
          var amount = 129800
          if (self.style === '0') {
            if (this.whichTest === '定性検査 +14,300') {
              amount = 124300
            }
          } else {
            if (this.whichTest === 'Qualitative Test +14,300') {
              amount = 124300
            }
          }

          var url = null
          if (document.URL.includes('localhost:8080')) {
            url = 'https://weart-marketing.com/api/test/'
          } else {
            url = 'https://weart-marketing.com/api/'
          }


          
          data = { 'token': this.tokenId, 'amount': amount, 'description': this.userId, 'plan': 3 }
            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {
              // 購入完了情報をユーザー情報に保存

            
              self.updateUserClass(data)

              // 購入完了ページへ
              //location.href = '/success?plan=1'

            }).fail(function () {
              self.loading = false
              if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
              } else {
                alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
          
          break
        default:

      }
    },
    updateUserClass: function (id) {
      var data = null
      let self = this


      console.log(id)
      console.log(String(id))

      if (document.URL.includes('localhost:8080')) {

        console.log('テストなのでこの後はメールを飛ばします。')

         self.getAllPlace()


      }  else {

        console.log('本番なのでこの後はメールを飛ばします。')

        var isSymptom = null
      if (self.style === '0') {
        if (this.selected === '有') {
          isSymptom = true
        } else {
          isSymptom = false
        }
      } else {
        if (this.selected === 'yes') {
          isSymptom = true
        } else {
          isSymptom = false
        }
      }
      
        switch (this.plan) {
          case 0:
            // 決済完了情報を保存する(userId, place, plan, passportURL, ticketURL, budate)
            var amount = 22000
            if (self.style === '0') {
              if (this.isExpress === '有') {
                amount = amount + 5500
              } 
            } else {
              if (this.isExpress === 'yes') {
                amount = amount + 5500
              } 
            }
            
            let collection = self.db.collection('payments')
            var doc = null
            if (self.plan === 0) {

              switch (self.whichTestForGuest) {
                case "宿泊前検査":
                  doc = {
                      userId: self.userId,
                      name: self.name,
                      tel: self.tel,
                      room: self.room,
                      address: self.address,
                      place: self.hotelName,
                      amount: amount,
                      payjpId: id,
                      isSymptom: isSymptom,
                      plan: self.plan,
                      category: 0,
                      passportURL: null,
                      ticketURL: null,
                      buyDate: new Date()
                  }

                case "ご帰宅後検査":
                  doc = {
                      userId: self.userId,
                      name: self.name,
                      tel: self.tel,
                      room: self.room,
                      address: self.address,
                      place: self.hotelName,
                      amount: amount,
                      payjpId: id,
                      isSymptom: isSymptom,
                      plan: self.plan,
                      category: 1,
                      passportURL: null,
                      ticketURL: null,
                      buyDate: new Date()
                  }
                case "宿泊中検査":
                  doc = {
                      userId: self.userId,
                      name: self.name,
                      tel: self.tel,
                      room: self.room,
                      address: self.address,
                      place: self.hotelName,
                      amount: amount,
                      payjpId: id,
                      isSymptom: isSymptom,
                      plan: self.plan,
                      category: 2,
                      passportURL: null,
                      ticketURL: null,
                      buyDate: new Date()
                   }
                default:
              }

            } else {

              doc = {
                  userId: self.userId,
                  place: self.hotelName,
                  amount: amount,
                  payjpId: id,
                  isSymptom: isSymptom,
                  plan: self.plan,
                  passportURL: null,
                  ticketURL: null,
                  buyDate: new Date()
              }

            }
            
            collection.add(doc).then(function (docRef) {


              // 宿泊前検査・ご帰宅後検査・宿泊中検査により異なる
              var data = null
              switch (self.whichTestForGuest) {
                case "宿泊前検査":
                data = { 'name': self.name, 'tel': self.tel,'address': self.address, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }
                case "ご帰宅後検査":
                data = { 'name': self.name, 'tel': self.tel,'address': self.address, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }
                case "宿泊中検査":
                data = { 'name': self.name, 'tel': self.tel, 'room': self.room, 'address': null, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }
                default:
              }

              const docRef1 = self.db.collection('users').doc(self.userId)
              docRef1.update(data).then(function () {

                // 購入完了のメール送信
                self.getAllPlace()

                // 購入完了ページへ
                //location.href = '/success?plan=0'

              }).catch(function () {
                self.loading = false
                if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
                } else {
                  alert('System error has temporarily occurred.')
                }
                location.href = "/error?style=" + self.style
                self.isConfirmPopup = false
              })
              
                
            }).catch(function (error) {
              self.loading = false
              if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
              } else {
                alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
          case 1:
            console.log('ここは来ない')
            break
          case 2:
            // パスポート画像とフライトチケットをfirestorageへ保存
            var passport_image = null
            var ticket_image = null
           
            var passportFileCheck = $("#passport_image").val().length
            if(passportFileCheck == 0){

            }else{
              passport_image = document.getElementById('passport_image').files[0].name
            }

            var ticketFileCheck = $("#ticket_image").val().length
            if(ticketFileCheck == 0){
              
            }else{
              ticket_image = document.getElementById('ticket_image').files[0].name
            }

            // ストレージ
            var storage = firebase.storage()
            var storageRef = storage.ref()

            // チケット写真があるかどうか
            if (!ticket_image) {
              var passportImagesRef = storageRef.child('images/passport/' + passport_image)
              var file =  document.getElementById('passport_image').files[0]
              passportImagesRef.put(file).then(function(snapshot) {
                // パスポートのパスを登録
                storageRef.child('images/passport/' + passport_image).getDownloadURL().then(function(url) {

                  console.log(url)
                  self.uploadedPassportImage = url

                  let collection = self.db.collection('payments')
                  var doc = {
                      userId: self.userId,
                      name: self.name,
                      tel: self.tel,
                      room: self.room,
                      address: self.address,
                      place: self.hotelName,
                      amount: 44000,
                      payjpId: id,
                      isSymptom: isSymptom,
                      plan: self.plan,
                      passportURL: url,
                      ticketURL: null,
                      buyDate: new Date()
                  }
                  collection.add(doc).then(function (docRef) {


                    data = { 'name': self.name, 'tel': self.tel, 'room': self.room, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }

                    const docRef1 = self.db.collection('users').doc(self.userId)
                    docRef1.update(data).then(function () {
                      // 購入完了のメール送信
                      self.getAllPlace()
                      // 購入完了ページへ
                      //location.href = '/success?plan=2'

                    }).catch(function () {
                      self.loading = false
                      if (self.style === '0') {
                        alert('一時的なサーバーエラーが発生しました。')
                      } else {
                        alert('System error has temporarily occurred.')
                      }
                      location.href = "/error?style=" + self.style
                      self.isConfirmPopup = false
                    })
                    
                      
                  }).catch(function (error) {
                    self.loading = false
                    if (self.style === '0') {
                      alert('一時的なサーバーエラーが発生しました。')
                    } else {
                      alert('System error has temporarily occurred.')
                    }
                    location.href = "/error?style=" + self.style
                  })
    
                }).catch(function(error) {
                  self.loading = false
                  // Handle any errors
                  if (self.style === '0') {
                    alert('一時的なサーバーエラーが発生しました。')
                  } else {
                    alert('System error has temporarily occurred.')
                  }
                  location.href = "/error?style=" + self.style
                  self.isConfirmPopup = false
                });
              });

            } else {
              var passportImagesRef = storageRef.child('images/passport/' + passport_image)
              var file =  document.getElementById('passport_image').files[0]
              var passportURL = null
              var ticketURL  = null
              passportImagesRef.put(file).then(function(snapshot) {

                storageRef.child('images/passport/' + passport_image).getDownloadURL().then(function(url) {
                  passportURL = url
                  console.log(url)
                  var ticketImagesRef = storageRef.child('images/ticket/' + ticket_image)
                  var file =  document.getElementById('ticket_image').files[0]
                  ticketImagesRef.put(file).then(function(snapshot) {

                    // パスポート・チケットのパスを登録
                    storageRef.child('images/ticket/' + ticket_image).getDownloadURL().then(function(url) {
                      ticketURL = url
                      console.log(url)

                      self.uploadedPassportImage = passportURL
                      self.uploadedTicketImage = ticketURL


                      let collection = self.db.collection('payments')
                      var doc = {
                          userId: self.userId,
                          name: self.name,
                          tel: self.tel,
                          room: self.room,
                          address: self.address,
                          place: self.hotelName,
                          amount: 44000,
                          isSymptom: isSymptom,
                          payjpId: id,
                          plan: self.plan,
                          passportURL: passportURL,
                          ticketURL: ticketURL,
                          buyDate: new Date()
                      }
                      collection.add(doc).then(function (docRef) {


                        data = { 'name': self.name, 'tel': self.tel, 'room': self.room, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }

                        const docRef1 = self.db.collection('users').doc(self.userId)
                        docRef1.update(data).then(function () {
                          // 購入完了のメール送信
                          self.getAllPlace()
                          // 購入完了ページへ
                          //location.href = '/success?plan=2'

                        }).catch(function () {
                          self.loading = false
                          if (self.style === '0') {
                            alert('一時的なサーバーエラーが発生しました。')
                          } else {
                            alert('System error has temporarily occurred.')
                          }
                          location.href = "/error?style=" + self.style
                          self.isConfirmPopup = false
                        })
                        
                          
                      }).catch(function (error) {
                        self.loading = false
                        if (self.style === '0') {
                          alert('一時的なサーバーエラーが発生しました。')
                        } else {
                          alert('System error has temporarily occurred.')
                        }
                        location.href = "/error?style=" + self.style
                      })               
        
                    }).catch(function(error) {
                      self.loading = false
                      // Handle any errors
                      if (self.style === '0') {
                        alert('一時的なサーバーエラーが発生しました。')
                      } else {
                        alert('System error has temporarily occurred.')
                      }
                      location.href = "/error?style=" + self.style
                      self.isConfirmPopup = false
                    });
                  });
    
                }).catch(function(error) {
                  self.loading = false
                  // Handle any errors
                  if (self.style === '0') {
                    alert('一時的なサーバーエラーが発生しました。')
                  } else {
                    alert('System error has temporarily occurred.')
                  }
                  location.href = "/error?style=" + self.style
                  self.isConfirmPopup = false
                });
              });
            }
            break
          case 3:
            
            // ここで１と同様にDBへ保存
            // 決済完了情報を保存する(userId, place, plan, passportURL, ticketURL, budate)
            var amount = 129800
            if (self.style === '0') {
              if (this.whichTest === '定性検査 +14,300') {
                amount = 124300
              }
            } else {
              if (this.whichTest === 'Qualitative Test +14,300') {
                amount = 124300
              }
            }
            
           
            let collection2 = self.db.collection('payments')
            var doc = {
                userId: self.userId,
                name: self.name,
                tel: self.tel,
                room: self.room,
                address: self.address,
                place: self.hotelName,
                amount: amount,
                payjpId: id,
                isSymptom: isSymptom,
                plan: self.plan,
                passportURL: null,
                ticketURL: null,
                buyDate: new Date()
            }
            collection2.add(doc).then(function (docRef) {


              data = { 'name': self.name, 'tel': self.tel, 'room': self.room, 'paymentIds': firebase.firestore.FieldValue.arrayUnion(docRef.id) }

              const docRef1 = self.db.collection('users').doc(self.userId)
              docRef1.update(data).then(function () {

                // 購入完了のメール送信
                self.getAllPlace()

                // 購入完了ページへ
                //location.href = '/success?plan=3'

              }).catch(function () {
                self.loading = false
                self.isConfirmPopup = false
                if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
                } else {
                  alert('System error has temporarily occurred.')
                }
                location.href = "/error?style=" + self.style
              })
              
                
            }).catch(function (error) {
              self.loading = false
              if (self.style === '0') {
                alert('一時的なサーバーエラーが発生しました。')
              } else {
                alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
            break
          default:
        }

      }

      
    },
    onTokenFailed (e) {
      console.error(e)
    },
    confirmPopup: function () {
      //購入するサービス・お名前・電話番号・お部屋番号
      let self = this
      if (!this.name) {
        if (self.style === '0') {
          alert('お名前が入力されてません。再度入力してから確認ボタンを押すようにしてください。')
        } else {
          alert('No name has been entered.Please try again.')
        }
        return
      }

      // プラン１かつ宿泊前検査・ご帰宅後検査の場合は送り先住所の項目あり
      if (this.plan === 0) {
        console.log('dbsajhdbjhsadbjhqwqw')
        console.log(this.whichTestForGuest)
        console.log('dbsajhdbjhsadbjhqwqw')
        if (this.whichTestForGuest === "宿泊前検査" || this.whichTestForGuest === "ご帰宅後検査") {
          if (!this.address) {
            if (self.style === '0') {
              alert('送付先住所が入力されてません。再度入力してから確認ボタンを押すようにしてください。')
            } else {
              alert('No address has been entered.Please try again.')
            }
            return
            
          }

        } 
      }


      if (!this.tel) {
        if (self.style === '0') {
          alert('電話番号が入力されてません。再度入力してから確認ボタンを押すようにしてください。')
        } else {
          alert('No tel number has been entered.Please try again.')
        }
        return
      }

      var tel = this.tel.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
      if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        if (this.style === '0') {
            alert('電話番号の入力が正しくありません。')
            return
        } else {
            alert('The phone number is entered incorrectly.')
            return
        }
      }



      // プラン１かつ宿泊前検査・ご帰宅後検査の場合は部屋番号の項目なし
      if (this.plan === 0) {
        if (this.whichTestForGuest === "宿泊前検査" || this.whichTestForGuest === "ご帰宅後検査") {

        } else {

          if (!this.hotelName === 'C') {
            if (!this.room) {
              if (self.style === '0') {
                alert('お部屋番号が入力されてません。再度入力してから確認ボタンを押すようにしてください。')
              } else {
                alert('No room number has been entered.Please try again.')
              }
              return
              
            }
          }

        }
      } else {
        if (!this.hotelName === 'C') {
          if (!this.room) {
            if (self.style === '0') {
              alert('お部屋番号が入力されてません。再度入力してから確認ボタンを押すようにしてください。')
            } else {
              alert('No room number has been entered.Please try again.')
            }
            return
            
          }
        }


      }

      
      
      switch (this.plan) {
        case 0:
           // エクスプレス対応の有無を確認
          if (!this.isExpress) {
            if (self.style === '0') {
              alert('エクスプレス対応の有無が選択されてません。再度選択してから確認ボタンを押すようにしてください。')
            } else {
              alert('The presence or absence of express is not selected.Please try again.')
            }
            return
          }
          if (self.style === '0') {
            if (this.isExpress === '有') {
              this.product = '宿泊者様PCR検査 27,500(税込)'
            } else {
              this.product = '宿泊者様PCR検査 22,000(税込)'
            }
          } else {
            if (this.isExpress === 'yes') {
              this.product = 'PCR test for guests 27,500(tax included)'
            } else {
              this.product = 'PCR test for guests 22,000(tax included)'
            }
          }
          
          break
        case 1:
          if (self.style === '0') {
            this.product = 'パーティ参加者様事前PCR検査 15,400(税込)'
          } else {
            this.product = 'PCR test for Wedding and Party 15,400(tax included)'
          }
          break
        case 2:
          if (self.style === '0') {
            this.product = '海外渡航陰性証明書 44,000(税込)'
          } else {
            this.product = 'PCR test negative certificate for overseas travel 44,000(tax included)'
          }
          // パスポート画像の登録があるかどうか？
          if (!this.uploadedPassportImage) {
            
            if (self.style === '0') {
              alert('パスポートの画像がアップロードされてません。再度アップロードしてから確認ボタンを押すようにしてください。')
            } else {
              alert('Image of your passport not uploaded.Please try again.')
            }
            return
          }

          break
        case 3:
          if (!this.whichTest) {
            if (self.style === '0') {
              alert('検査の種類が選択されてません。再度選択してから確認ボタンを押すようにしてください。')
            } else {
              alert('The presence or absence of test category is not selected.Please try again.')
            }
            return
          }
          if (self.style === '0') {
            if (this.whichTest === '定性検査 +14,300') {
              this.product = '医師派遣&抗原検査 124,300(税込)'
            } else {
              this.product = '医師派遣&抗原検査 129,800(税込)'
            }
          } else {
            if (this.whichTest === 'Qualitative Test +14,300') {
              this.product = 'Dispatch of doctors plan & antigen test against COVID-19 124,300(tax included)'
            } else {
              this.product = 'Dispatch of doctors plan & antigen test against COVID-19 129,800(tax included)'
            }
          }
          // 症状の有無の選択があるかどうか
          break
        default:
          if (self.style === '0') {
            this.product = 'その他'
          } else {
            this.product = 'Other'
          }
      }
      if (!this.selected) {
        if (self.style === '0') {
          alert('症状の有無が選択されてません。再度選択してから確認ボタンを押すようにしてください。')
        } else {
          alert('The presence or absence of symptoms is not selected.Please try again.')
        }
        return
      }

      if (self.style === '0') {
         $('#payjp_checkout_box input[type=button]').val('決済情報を入力する');
      } else {
         $('#payjp_checkout_box input[type=button]').val('Please enter your test settlement information');

      }
      
      this.isConfirmPopup = true
    },
    close: function () {
      this.isConfirmPopup = false
    },
    check: function () {
      let self = this
      if (!this.passcode) {
        if (self.style === '0') {
          alert('パスコードが入力されていません。')
        } else {
          alert('No passcode has been entered.')
        }
        return
      }
      var exist = false
      this.loading = true

      this.db.collection('users').where('mail', '==', this.mail).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // パスコードを更新後、phpメール送信
          if (doc.get('passcode') == self.passcode) {
            exist = true
            self.userId = doc.id
            self.isPasscodeCorrect = true
            self.loading = false
          }
          
        })
        if (!exist) {
          self.isPasscodeCorrect = false
          if (self.style === '0') {
            alert('入力されたパスコードは一致しません。再度入力してください。')
          } else {
            alert('The passwords entered do not match. Please try again.')
          }
          self.loading = false

        }
      }).catch(function (error) {
        console.log(error)
        if (self.style === '0') {
          alert('一時的なサーバーエラーが発生しました。')
        } else {
          alert('System error has temporarily occurred.')
        }
        location.href = "/error?style=" + self.style
      })
    },
    onFileChange1(e) {
      let self = this
      let files = e.target.files || e.dataTransfer.files;
      const sizeLimit = 1024 * 1024 * 5;
      if (files[0].size > sizeLimit) {
        if (self.style === '0') {
          alert('ファイルサイズは5MB以下にしてください'); // エラーメッセージを表示
        } else {
          alert('File size should be 5MB or less.'); // エラーメッセージを表示
        }
        return;
      } else {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedPassportImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },
    onFileChange2(e) {
      let self = this
      let files = e.target.files || e.dataTransfer.files;
      const sizeLimit = 1024 * 1024 * 5;
      if (files[0].size > sizeLimit) {

        if (self.style === '0') {
          alert('ファイルサイズは5MB以下にしてください'); // エラーメッセージを表示
        } else {
          alert('File size should be 5MB or less.'); // エラーメッセージを表示
        }

        return;
      } else {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedTicketImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      }
      
    },
    getAllPlace: function () {

      let self = this
      self.places = []
      this.db.collection('places').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var hash = {}
          hash['id'] = doc.get('id')
          hash['name'] = doc.get('name')
          hash['english'] = doc.get('english')
          hash['mail'] = doc.get('mail')
          hash['mail2'] = doc.get('mail2')
          
          self.places.push(hash)
        })
        self.sendEmail()
      }).catch(function (error) {
        
      })
    },
    sendEmail: function () {
      // プランによって送信先が違う？
      let self = this
    
      
      var hotel = ''
      var hotelAddress = ''
      var hotelAddress2 = ''
      const index = self.places.findIndex((p) => p.id === self.hotelName)
          if (index === -1) {
            if (index === 0) {
              if (self.style === '0') {
                  hotel = self.places[0].name
                  hotelAddress = self.places[0].mail
                  hotelAddress2 = self.places[0].mail2


              } else {
                  hotel = self.places[0].english
                  hotelAddress = self.places[0].mail
                  hotelAddress2 = self.places[0].mail2
              }
            } else {
              if (self.style === '0') {
                  hotel = '存在しないホテル'
                  hotelAddress = 'takuya.haruna@waert.co.jp'// 存在しないホテルの場合春名に届くようにする
                  hotelAddress2 = 'takuya.haruna@waert.co.jp'
              } else {
                  hotel = 'None hotel'
                  hotelAddress = 'takuya.haruna@waert.co.jp'// 存在しないホテルの場合春名に届くようにする
                  hotelAddress2 = 'takuya.haruna@waert.co.jp'
              }
            }
          } else {
            if (self.style === '0') {
                hotel = self.places[index].name
                hotelAddress = self.places[index].mail
                hotelAddress2 = self.places[index].mail2
            } else {
                hotel = self.places[index].english
                hotelAddress = self.places[index].mail
                hotelAddress2 = self.places[index].mail2
            }
          }


          console.log('dejdewjdvejwdvew')
          console.log(hotelAddress)
          console.log(self.address)
           console.log('dejdewjdvejwdvew')

      // 症状の有無もメールで飛ばす
      
      var data = null

      if (self.plan === 2) {
        
        // チケット写真があるかどうか
        if (!self.uploadedTicketImage) {
          data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'passportURL': self.uploadedPassportImage, 'selected': self.selected, 'hotelName': hotel, 'hotelAddress': hotelAddress, 'hotelAddress2': hotelAddress2   }
        } else {

          data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'passportURL': self.uploadedPassportImage, 'ticketURL': self.uploadedTicketImage, 'selected': self.selected, 'hotelName': hotel, 'hotelAddress': hotelAddress, 'hotelAddress2': hotelAddress2    }
        }

      } else {
        if (self.plan === 0) {

         // 英語の場合はカテゴリを英語にする
         if (self.style === '0') {
          
          switch (self.whichTestForGuest) {
              case "宿泊前検査":

              console.log('gfnseojfeosnjsdjfesf');
              console.log(hotelAddress);
              console.log(hotelAddress2);
              console.log('gfnseojfeosnjsdjfesf');
              
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': self.whichTestForGuest, 'address': self.address, 'hotelAddress2': hotelAddress2   }
            
              break

              case "ご帰宅後検査":
            
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': self.whichTestForGuest, 'address': self.address, 'hotelAddress2': hotelAddress2   }

              break

              case "宿泊中検査":
             
              console.log('Dqwdkqwdqwdqw')
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': self.whichTestForGuest, 'address': 'NULL', 'hotelAddress2': hotelAddress2   }

              break
              default:
            }
         } else {


          var engCategory = ''
          switch (self.whichTestForGuest) {
              case "宿泊前検査":
              engCategory = 'The test before check-in'
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': engCategory, 'address': self.address, 'hotelAddress2': hotelAddress2   }
              break
              case "ご帰宅後検査":
              engCategory = 'The test after returning home'
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': engCategory, 'address': self.address , 'hotelAddress2': hotelAddress2  }
              break
              case "宿泊中検査":
              engCategory = 'The test during your stay'
              data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'isExpress': self.isExpress, 'hotelName': hotel, 'hotelAddress': hotelAddress , 'category': engCategory, 'address': 'NULL' , 'hotelAddress2': hotelAddress2  }
              break
              default:
            }

          
         }
         
         
        } else {
          if (self.plan === 3) {
            // 検査の種類
             data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'hotelName': hotel, 'hotelAddress': hotelAddress, 'whichTest': self.whichTest , 'hotelAddress2': hotelAddress2   }
          } else {
            data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'room': self.room,'plan': self.plan, 'place': hotel, 'selected': self.selected, 'hotelName': hotel, 'hotelAddress': hotelAddress  , 'hotelAddress2': hotelAddress2  }
          }
        }
      }

    


      var url = null

       if (document.URL.includes('localhost:8080')) {
            // テスト環境
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/test/successMail/'
            } else {
                url = 'https://weart-marketing.com/api/test/successMail/en/'
            }
       } else {
            // 本番環境
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/successMail/'
            } else {
                url = 'https://weart-marketing.com/api/successMail/en/'
            }
       }
            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {

              switch (self.plan) {
                case 0: 
                  location.href = '/success?plan=0&style=' + self.style
                  return
                case 1:
                  return
                case 2:
                  location.href = '/success?plan=2&style=' + self.style
                  return
                case 3:
                  location.href = '/success?plan=3&style=' + self.style
                  return
              }
            }).fail(function () {
              
            })
    }
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue